import { render, staticRenderFns } from "./benefitMore.vue?vue&type=template&id=050b00a6&scoped=true&"
import script from "./benefitMore.vue?vue&type=script&lang=js&"
export * from "./benefitMore.vue?vue&type=script&lang=js&"
import style0 from "./benefitMore.vue?vue&type=style&index=0&id=050b00a6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050b00a6",
  null
  
)

export default component.exports